import { InjectionToken, ViewContainerRef } from "@angular/core";
import { AriaLivePoliteness } from "@angular/cdk/a11y";
import { Direction } from "@angular/cdk/bidi";

/** Injection token that can be used to access the data that was passed in to a toast. */
export const VDS_TOAST_DATA = new InjectionToken<any>("VdsToastData");

/** Possible values for horizontalPosition on VdsToastConfig. */
export type VdsToastHorizontalPosition = "start" | "center" | "end" | "left" | "right";

/** Possible values for verticalPosition on VdsToastConfig. */
export type VdsToastVerticalPosition = "top" | "bottom";

/** Possible alert classes on VdsToastConfig */
export type VdsToastType = "info" | "success" | "warning" | "error" | "loading";

/**
 * Configuration used when opening a toast.
 */
export class VdsToastConfig<D = any> {
    /** The politeness level for the MatAriaLiveAnnouncer announcement. */
    politeness?: AriaLivePoliteness = "assertive";

    /**
     * Message to be announced by the LiveAnnouncer. When opening a toast without a custom
     * component or template, the announcement message will default to the specified message.
     */
    announcementMessage?: string = "";

    /** The view container to place the overlay for the toast into. */
    viewContainerRef?: ViewContainerRef;

    /** The length of time in milliseconds to wait before automatically dismissing the toast. */
    duration?: number = 0;

    /** Extra CSS classes to be added to the toast container. */
    panelClass?: string | string[];

    /** The type of toast to show. */
    type?: VdsToastType = "info";

    /** Text layout direction for the toast. */
    direction?: Direction;

    /** Data being injected into the child component. */
    data?: D | null = null;

    /** The horizontal position to place the toast. */
    horizontalPosition?: VdsToastHorizontalPosition = "center";

    /** The vertical position to place the toast. */
    verticalPosition?: VdsToastVerticalPosition = "bottom";
}
